import { render, staticRenderFns } from "./Payslip.vue?vue&type=template&id=1f571146&scoped=true"
import script from "./Payslip.vue?vue&type=script&lang=js"
export * from "./Payslip.vue?vue&type=script&lang=js"
import style0 from "./Payslip.vue?vue&type=style&index=0&id=1f571146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f571146",
  null
  
)

export default component.exports